import React from 'react';
import PropTypes from 'prop-types';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { FieldTemplate } from '../../01_atoms/FormElements';

const debug = require('debug')('cw:DonationStripeButton');

/**
 * Integrate Stripe Elements with React Final Form.
 */
const StripeElementFieldAdapter = ({ input, elementType, id, placeholder = '' }) => {
  // Because Stripe fields are rendered inside iFrame, styling is limited.
  // See https://stripe.com/docs/js/appendix/style.
  const stripeProps = {
    id,
    options: {
      style: {
        base: {
          fontSize: '16px',
          color: ' #212431',
          fontFamily: 'IBM Plex Sans, Helvetica, Arial, sans-serif',
          '::placeholder': {
            color: '#b2b2c2',
          },
        },
        invalid: {
          color: ' #212431',
        },
      },
      placeholder,
    },
    // Stripe exposes metadata about each card field that we will use in
    // final-form validators.
    // See https://stripe.com/docs/js/element/events/on_change
    onChange: ({ complete, brand, empty, error }) =>
      input.onChange({ complete, brand, error, value: empty ? '' : 'not empty' }),
    onBlur: () => input.onBlur(),
    onFocus: () => input.onFocus(),
  };

  if (elementType === 'cardNumber') {
    stripeProps.options.disableLink = true;
    return <CardNumberElement {...stripeProps} />;
  }
  if (elementType === 'cardExpiry') {
    return <CardExpiryElement {...stripeProps} />;
  }
  if (elementType === 'cardCvc') {
    return <CardCvcElement {...stripeProps} />;
  }

  debug('Unsupported Stripe Element type', elementType);
  return null;
};

StripeElementFieldAdapter.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
  }).isRequired,
  elementType: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

const StripeElementField = (props) => (
  <FieldTemplate
    type="text"
    /* eslint-disable-next-line react/style-prop-object */
    style="normal"
    component={StripeElementFieldAdapter}
    {...props}
  />
);

export default StripeElementField;
